/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
function n(n,o){for(const f of n)if(null!=f&&o(f))return f}export{n as find};
